// 公告列表
export const switchPackage = params => {
  return window._this.$http.post(`/erp/machine/unbindPackage`, params);
};



// WEBPACK FOOTER //
// ./src/api/machine.js